import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from './NativeContainerElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { InteractiveElementbmyfh3g220bh as InteractiveElement } from './InteractiveElement.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NativeElement2p8z5z0r9meck as NativeElement } from './NativeElement.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NativeInteractiveContainerElementClass;
function NativeInteractiveContainerElement() {
  if (NativeInteractiveContainerElementClass === VOID) {
    class $ extends NativeContainerElement() {
      set_enabled_tswf75_k$(value) {
        var tmp0 = this.native_1.attributes_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.native_1.disabled = value_0;
        this.native_1.setAttribute_j9pxft_k$('aria-disabled', value ? null : 'true');
      }
      get_enabled_pcr8o8_k$() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.native_1.attributes_1.native_1.disabled;
        return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
      }
    }
    initMetadataForClass($, 'NativeInteractiveContainerElement', VOID, VOID, [InteractiveElement()]);
    NativeInteractiveContainerElementClass = $;
  }
  return NativeInteractiveContainerElementClass;
}
var NativeInteractiveElementClass;
function NativeInteractiveElement() {
  if (NativeInteractiveElementClass === VOID) {
    class $ extends NativeElement() {
      set_enabled_tswf75_k$(value) {
        var tmp0 = this.native_1.attributes_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.native_1.disabled = value_0;
        this.native_1.setAttribute_j9pxft_k$('aria-disabled', value ? null : 'true');
      }
      get_enabled_pcr8o8_k$() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.native_1.attributes_1.native_1.disabled;
        return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
      }
    }
    initMetadataForClass($, 'NativeInteractiveElement', VOID, VOID, [InteractiveElement()]);
    NativeInteractiveElementClass = $;
  }
  return NativeInteractiveElementClass;
}
//region block: exports
export {
  NativeInteractiveContainerElement as NativeInteractiveContainerElement1pn7ly9a3ij8y,
  NativeInteractiveElement as NativeInteractiveElementnutmif7l5rxf,
};
//endregion

//# sourceMappingURL=InteractiveElement.commonHtml.mjs.map
